import React from 'react';
import { useTranslation } from 'react-i18next';
import FileUploadModal from 'components/molecules/csvUploadModal';
import { BATCH_ZIP_REPORT } from 'services/dataService/resources';
import dataService from 'services/dataService';
import useAlert from 'infrastructure/hooks/utils/use-alert';
import { showResult } from 'infrastructure/hooks/utils';

interface IProps {
  isOpen: boolean;
  toggle: () => void;
}

const GenerateZipReportModal: React.FC<IProps> = ({ isOpen, toggle }) => {
  const { t } = useTranslation();
  const { Alert, showAlert } = useAlert();

  const uploadCsvFile = async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    const timezoneOffset = new Date().getTimezoneOffset();

    const { error, data } = await dataService.uploadFile(
      `${BATCH_ZIP_REPORT}?timezoneOffset=${timezoneOffset}`,
      formData,
      'POST',
    );

    if (error) showResult(error);

    if (data) {
      showAlert({
        title: t('adminTools.batchZipTitle'),
        message: t('adminTools.batchZipMessage'),
        type: 'primary',
        showReject: false,
      });
    }

    toggle?.();
    return {};
  };

  return (
    <>
      <FileUploadModal
        isOpen={isOpen}
        toggle={toggle}
        title={t('adminTools.generateBatchPatientReports')}
        sampleFileUrl="/csvTemplates/generateZip.csv"
        uploadCsvFile={uploadCsvFile}
      />
      {Alert}
    </>
  );
};

export default GenerateZipReportModal;
